import React from "react";
import { Card, Image, Space, Typography } from "antd";
import { FilePdfOutlined, EyeOutlined } from "@ant-design/icons";
import classes from "./DocumentPreview.module.scss";

const { Text } = Typography;

const handleOpenDocument = (url) => {
  window.open(url, "_blank");
};

const DocumentPreview = ({ document, documentUrl }) => {
  if (!document?.s3_key) return <Text>Nenhum documento anexado</Text>;

  if (document.content_type?.startsWith("image/")) {
    return (
      <Card bordered={false} style={{ width: 500 }}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Image
            width={500}
            src={documentUrl}
            alt="Documento enviado"
            rootClassName={classes.ImagePreview}
          />
        </div>
      </Card>
    );
  }

  if (document.content_type === "application/pdf") {
    return (
      <Card
        hoverable
        onClick={() => handleOpenDocument(documentUrl)}
        style={{
          width: 300,
          textAlign: "center",
          cursor: "pointer",
        }}
      >
        <Space direction="vertical" size="middle">
          <FilePdfOutlined
            style={{
              fontSize: 80,
              color: "#ff4d4f",
            }}
          />

          <Text type="secondary">
            <EyeOutlined /> Clique para visualizar
          </Text>
        </Space>
      </Card>
    );
  }

  return (
    <Card>
      <Text>Formato não suportado para visualização.</Text>
    </Card>
  );
};

export default DocumentPreview;
